module.exports = __webpack_public_path__ + "static/Arkipelago-8d60d9104579c47ed7aed99f61cba541.otf";